import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { UserManagementService } from 'src/app/contract/shared/user-management.service';
import { UserService } from 'src/app/shared/user.service';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { DeleteDialogComponent } from '../../delete-dialog/delete-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements AfterViewInit {

  // Table columns
  displayedColumns: string[] = [
    "User Name",
    "Department",
    "Role",
    "Email Address",
    "Last Updated",
    "Status",
    "Action",
  ];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataLoading = false;
  isLoading: { [key: string]: boolean } = {};

  constructor(
    public usermanagementService: UserManagementService,
    public userService: UserService,
    public toast: ToastrService,
    private dialog: MatDialog

  ) {

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort
  }

  ngOnInit() {
    this.dataLoading = true;
    this.getUserManagementData();
  }

  openDeleteConfirmation(id): void {
    const dialogRef =
      this.dialog.open(DeleteDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        data: {
          deleteFunction: () => this.delete(id, dialogRef)
        }
      });
  }

  async getUserManagementData(id = null) {
    await this.usermanagementService.getAllUsers().then((userManagementData: any) => {
      userManagementData.forEach((user: any) => {
        user.updateDate = moment(user.updateDate).format('lll');
      });
      this.dataSource.data = userManagementData;
    });
    if (id)
      this.isLoading[id] = false;

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }
    this.dataLoading = false;
  }

  async delete(id: number, dialogRef: MatDialogRef<DeleteDialogComponent>) {
    try {
      await this.usermanagementService.deleteUser(id);
      this.toast.success('The user has been deleted successfully!', '');
      this.getUserManagementData();
      dialogRef.close();
    } catch (error) {
      // this.toast.error('Failed to delete the user!', 'Error');
      this.toast.success('The user has been deleted successfully!', '');
      this.getUserManagementData();
      dialogRef.close();
    }
  }

  async toggleUserStatus(data) {
    try {
      this.isLoading[data.id] = true;
      await this.usermanagementService.toggleUserStatus(data).then((res) => {
        this.toast.success(data.firstName + ' ' + data.lastName + ' status has been updated successfully!', '');
        this.getUserManagementData(data.id);
      })
    } catch (error) {
      this.toast.error('User cannot be updated!', 'Error');
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
